module.exports = __webpack_public_path__ + "static/media/first_issue.ef3386af.jpg";